import { useState } from "react";
import { Input } from "./universalInput";

export function MinMaxPicker({
  value,
  type,
  placeholder,
  variableSectionsContext,
  onChange,
}: {
  value: { min: any; max: any } | null | undefined;
  type: "variable" | "number" | "datetime" | "date";
  placeholder?: string;
  variableSectionsContext?: any | undefined;
  onChange: (newValue: { min: any; max: any } | null | undefined) => void;
}) {
  let [localValue, setLocalValue] = useState(
    typeof value == "object" ? value : { min: null, max: null }
  );

  function onValueChange(newValue: any, key: "min" | "max") {
    localValue ||= { min: null, max: null };
    localValue[key] = newValue;
    if (type != "variable") setLocalValue({ ...localValue });
    onChange?.(localValue);
  }

  return (
    <div className="c2 gap15">
      <Input
        name="Min"
        placeholder="Min..."
        type={type}
        value={localValue?.min}
        onChange={(newValue) => {
          onValueChange(newValue, "min");
        }}
      ></Input>
      <Input
        name="Max"
        placeholder="Max..."
        type={type}
        value={localValue?.max}
        onChange={(newValue) => {
          onValueChange(newValue, "max");
        }}
      ></Input>
    </div>
  );
}
